// Module
var code = `<div class="modal-dialog destinationModal" role="document">
    <div class="modal-content neo-modal">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-cancel"></i></button>
            <div class="d-flex align-items-center gap-2">
                <h3 class="modal-title">Choose a Server-Wide Task</h3>
                <span class="badge license-restricted-badge professional" data-bind="if: !\$root.hasServerWideBackups && !\$root.hasServerWideExternalReplications">Professional +</span>
            </div>
        </div>
        <div class="modal-body">
            <div class="padding padding-sm text-center">
                <div class="row row-sm flex-row">
                    <div class="col-sm-6 d-flex" title="Create new Server-Wide External Replication task">
                        <a href="#" class="external-replication d-flex flex-grow" data-bind="click: newServerWideReplicationTask">
                            <i class="icon-server-wide-replication"></i><h4 class="margin-none margin-top-sm">Server-Wide External Replication</h4>
                        </a>
                    </div>
                    <div class="col-sm-6 d-flex" title="Create new Server-Wide Backup task">
                        <a href="#" class="periodic-backup d-flex flex-grow" data-bind="click: newServerWideBackupTask">
                            <i class="icon-server-wide-backup"></i><h4 class="margin-none margin-top-sm">Server-Wide Periodic Backup</h4>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;